<template>
    <div class="mb-4">
        <div class="product-reviews">
            <div class="product_wr product_wr__first">
                <div class="product_right">
                    <div class="product_right_in">
                        <div class="d-flex justify-content-start">
                            <ProductRating
                                prefix="product_reviews"
                                :readonly="true"
                                :hide-review-link="true"
                                :value="store.ratingInfo.value_raw"
                            />
                        </div>
                        <RatingBreakdown/>
                        <RatingOverview ref="overviewRef"/>
                        <ModalContent id="ProductReviewModal"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, defineExpose } from 'vue'
import { useProductPageStore } from '~/stores/ProductPageStore'
const RatingBreakdown = defineAsyncComponent(() => import('~/components/Product/Page/Ratings/RatingBreakdown.vue'))
const RatingOverview = defineAsyncComponent(() => import('~/components/Product/Page/Ratings/RatingOverview.vue'))
const ModalContent = defineAsyncComponent(() => import('~/components/Modals/ModalContent.vue'))
const ProductRating = defineAsyncComponent(() => import('~/components/Product/ProductRating.vue'))

const store = useProductPageStore()
const overviewRef = ref(null)

function loadRatings() {
    overviewRef.value?.loadRatings()
}

defineExpose({ loadRatings })
</script>
